interface LogoProps {
  className?: string
  showWordmark?: boolean
  size?: 'nav' | 'auth'
}

function Logo({ className = '', showWordmark = true, size = 'nav' }: LogoProps) {
  const imageClass = size === 'auth'
    ? 'h-24 w-auto max-w-[360px] object-contain sm:h-28 sm:max-w-[420px]'
    : showWordmark
      ? 'h-20 w-auto max-w-[360px] object-contain md:h-[5.5rem] md:max-w-[440px]'
      : 'h-16 w-auto max-w-[280px] object-contain object-left md:h-16 md:max-w-[280px]'

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="https://static.lumi.new/87/87b66f0de2d2e6518aeb0263c569c75c.webp"
        alt={showWordmark ? 'My Card Shop' : 'My Card Shop logo'}
        className={imageClass}
      />
    </div>
  )
}

export default Logo
